/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { withRouter } from "react-router-dom";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import consultaApi from "../../../services/consultaApi";
import dbToBoolean from "../../../tools/dbToBoolean";
//Icones
import MenuIcon from "@material-ui/icons/Menu"; //Menu
import AccountCircle from "@material-ui/icons/AccountCircle"; //Perfil
import HomeIcon from "@material-ui/icons/Home"; //Home
import SettingsIcon from "@material-ui/icons/Settings"; //Settings
import GroupRoundedIcon from "@material-ui/icons/GroupRounded"; //Pessoa
import LocalAtmRoundedIcon from "@material-ui/icons/LocalAtmRounded"; //Imposto
import DescriptionRoundedIcon from "@material-ui/icons/DescriptionRounded"; //NF
import ExitToAppRoundedIcon from "@material-ui/icons/ExitToAppRounded"; //Sair
import DevicesOtherRoundedIcon from "@material-ui/icons/DevicesOtherRounded"; //Produto
import FileCopyIcon from "@material-ui/icons/FileCopy"; //NFe
import theme from "../../layout/theme";
import { Grid } from "@material-ui/core";

const tema = theme();

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  titulo: {
    flexGrow: 1,
  },
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  heading: {
    paddingLeft: 15,
    fontStyle: "bold",
  },
  controlaLogo: {
    width: tema.logoWidth,
    // padding: 20,
  },
}));

function NavBar(props) {
  const { history, tourHelpers } = props;

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [textoHeader, setTextoHeader] = React.useState();
  const [acessos, setAcessos] = React.useState();

  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
  const [state, setState] = React.useState({
    left: false,
  });

  useEffect(() => {
    async function buscaAcesso() {
      const resposta = await consultaApi({ PROCNAME: "WEBSITE_ACESSO" });
      setAcessos({
        nfe: dbToBoolean(resposta.data.NFE),
        nfce: dbToBoolean(resposta.data.NFCE),
      });
    }
    buscaAcesso();
  }, []);

  useEffect(() => {
    setTimeout(alternaHeader(), 2000);
  }, [textoHeader]);

  useEffect(() => {
    tourHelpers &&
      setTimeout(() => {
        tourHelpers.next();
      }, 400);
  }, [state]);

  const open = Boolean(anchorEl);

  const controlaMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const fechaMenu = () => {
    setAnchorEl(null);
  };

  function vaiLogin() {
    history.push("/");
  }

  function vaiHome() {
    history.push("/home");
  }

  function vaiPessoa() {
    history.push("/pessoa");
  }

  function vaiProduto() {
    history.push("/produto");
  }

  function vaiGrupoImposto() {
    history.push("/grupo-imposto");
  }

  function vaiNfe() {
    history.push("/nfe");
  }

  // eslint-disable-next-line no-unused-vars
  function vaiNfce() {
    history.push("/nfce");
  }

  function vaiCertificado() {
    history.push("/certificado");
  }

  function vaiConfiguracoes() {
    history.push("/configuracoes");
  }

  let cont = 0;
  function alternaHeader() {
    cont++;
    if (cont % 2 == 0) {
      setTextoHeader(localStorage.getItem("LOGIN"));
    } else {
      if (localStorage.getItem("CNPJ") == localStorage.getItem("CONNAME")) {
        setTextoHeader(localStorage.getItem("CNPJ"));
      } else {
        setTextoHeader(localStorage.getItem("CONID"));
      }
    }
  }

  const toggleDrawer = (side, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const sideList = (side) => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        <ListItem>
          <Grid container>
            <Grid item xs={12} align="center">
              <img
                src={tema.logo}
                alt="SimpleWork"
                className={classes.controlaLogo}
                onClick={vaiHome}
              />
            </Grid>
          </Grid>
        </ListItem>
        <ListItem button key={1} onClick={vaiHome}>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
      </List>

      <Divider />
      {acessos && (
        <List id="nav-documentos">
          <Typography
            className={classes.heading}
            variant="h5"
            component="h5"
            gutterBottom
          >
            Documentos
          </Typography>
          {acessos.nfe && (
            <ListItem
              button
              key={1}
              onClick={vaiNfe}
              id="nav-cadastro-nota-fiscal"
            >
              <ListItemIcon>
                <DescriptionRoundedIcon />
              </ListItemIcon>
              <ListItemText primary="NF-e (55)" />
            </ListItem>
          )}
          {acessos.nfce && (
            <ListItem
              button
              key={1}
              onClick={vaiNfce}
              id="nav-cadastro-nota-fiscal-consumidor"
            >
              <ListItemIcon>
                <DescriptionRoundedIcon />
              </ListItemIcon>
              <ListItemText primary="NFC-e (65)" />
            </ListItem>
          )}
        </List>
      )}

      <Divider />

      <List id="nav-cadastros">
        <Typography
          className={classes.heading}
          variant="h5"
          component="h5"
          gutterBottom
        >
          Cadastros
        </Typography>
        <ListItem button key={1} onClick={vaiProduto} id="nav-cadastro-produto">
          <ListItemIcon>
            <DevicesOtherRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="Produto" />
        </ListItem>
        <ListItem button key={2} onClick={vaiPessoa} id="nav-cadastro-pessoa">
          <ListItemIcon>
            <GroupRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="Pessoa" />
        </ListItem>
        <ListItem
          button
          key={3}
          onClick={vaiGrupoImposto}
          id="nav-cadastro-grupo-imposto"
        >
          <ListItemIcon>
            <LocalAtmRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="Grupo de Imposto" />
        </ListItem>
      </List>

      <Divider />

      <List id="nav-conta">
        <Typography
          className={classes.heading}
          variant="h5"
          component="h5"
          gutterBottom
        >
          Conta
        </Typography>
        <ListItem button key={1} onClick={vaiCertificado} id="nav-certificado">
          <ListItemIcon>
            <FileCopyIcon />
          </ListItemIcon>
          <ListItemText primary="Certificado" />
        </ListItem>
        <ListItem button key={1} onClick={vaiConfiguracoes} id="nav-configurar">
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Configurações" />
        </ListItem>
        <ListItem button key={2} onClick={vaiLogin} id="nav-sair">
          <ListItemIcon>
            <ExitToAppRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="Sair" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer("left", true)}
            id="botao-nav"
          >
            <MenuIcon />
          </IconButton>

          {/* <Button onClick={toggleDrawer('left', true)}><MenuIcon /></Button> */}

          <SwipeableDrawer
            open={state.left}
            onClose={toggleDrawer("left", false)}
            onOpen={toggleDrawer("left", true)}
            disableBackdropTransition={!iOS}
            disableDiscovery={iOS}
            id="side-bar"
          >
            {sideList("left")}
          </SwipeableDrawer>

          <Typography variant="h6" className={classes.titulo}>
            {textoHeader}
          </Typography>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={controlaMenu}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={open}
            onClose={fechaMenu}
          >
            <MenuItem onClick={fechaMenu}>Minha Conta</MenuItem>
            <MenuItem onClick={vaiLogin}>Sair</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default withRouter(NavBar);
